"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RankingWidget = void 0;
var React = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var rankingWidgetTable_1 = require("./rankingWidgetTable");
var rankingHistoryRow_1 = require("./rankingHistoryRow");
var useQueryParamSynched_1 = require("../hooks/useQueryParamSynched");
var rankingLargestDeltas_1 = require("./rankingLargestDeltas");
var react_responsive_1 = require("react-responsive");
exports.RankingWidget = function (props) {
    var _a;
    var entries = props.entries;
    var isMobile = react_responsive_1.useMediaQuery({ query: '(max-width: 767px)' });
    var _b = useQueryParamSynched_1.useQueryParamSynched("municipality", (_a = lodash_1.default.head(entries)) === null || _a === void 0 ? void 0 : _a.name), municipality = _b[0], setMunicipality0 = _b[1];
    var selectedEntry = entries.find(function (e) { return e.name === municipality; });
    var setMunicipality = function (municipality) {
        if (isMobile) {
            window.location.href = "/find?name=" + municipality;
        }
        else {
            setMunicipality0(municipality);
        }
    };
    if (!selectedEntry || !municipality) {
        throw new Error("No entries provided.");
    }
    var ranks = selectedEntry.ranks;
    return (React.createElement("div", { className: "chart-ranking" },
        React.createElement("div", { key: "table", className: "rankings" },
            React.createElement(rankingWidgetTable_1.RankingWidgetTable, __assign({}, props, { setMunicipality: setMunicipality }))),
        !isMobile && React.createElement("div", { key: "data", className: "chart-stat" },
            React.createElement("div", { className: "chart-stat-header" },
                React.createElement("div", { className: "title" }, municipality),
                React.createElement("a", { href: "/find?name=" + municipality, className: "view-more" }, "Visa kommun")),
            React.createElement(rankingHistoryRow_1.RankingHistoryRow, { ranks: ranks, latestYear: props.sortYear }),
            React.createElement(rankingLargestDeltas_1.RankingLargestDeltas, { municipality: municipality }))));
};
